import maplibregl from 'maplibre-gl';
import { TEXT_LAYERS } from './text';

export const LAYER_IDS = {
    SELECTED_GOV: "selected_gov",
    GOVS_LINE: "adm1",
    GOVS: "adm0",
    GRID_HV: "grid_hv",
    GRID_LV: "grid_lv",
    GRID: "grid",
    POWER_PLANTS: "power_plants",
    SUBSTATIONS: "substations",
    SETTLEMENTS_ALL_CENTROIDS: "settlements_all_centroids",
    SURVEYED_SETTLEMENTS: "surveyed_settlements",
    SURVEYED_SETTLEMENTS_HALO: "surveyed_settlements_halo",
    SETTLEMENT_SELECTED: "settlement_selected",
    MINIGRIDS: "minigrids",
    WIND: "wind",
    PV: "pv",
    NES: "nes",
};

export const LAYER_ORDER_ARRAY = [
    LAYER_IDS.SETTLEMENTS_ALL_CENTROIDS,
    LAYER_IDS.SURVEYED_SETTLEMENTS_HALO,
    LAYER_IDS.SURVEYED_SETTLEMENTS,
    LAYER_IDS.SETTLEMENT_SELECTED,
    LAYER_IDS.GRID_HV,
    LAYER_IDS.GRID_LV,
    LAYER_IDS.POWER_PLANTS,
    LAYER_IDS.SUBSTATIONS,
    LAYER_IDS.MINIGRIDS,
    LAYER_IDS.WIND,
    LAYER_IDS.PV,
    LAYER_IDS.GOVS_LINE,    
    LAYER_IDS.GOVS,    
]

export const MAX_BOUNDS: maplibregl.LngLatBoundsLike =  [[27.0291, -30.6748],[29.4557, -28.5708]] ;
export const MAP_BOUNDS: maplibregl.LngLatBoundsLike = [[27.0291, -30.6748],[29.4557, -28.5708]] ;
export const MAP_CENTRE: maplibregl.LngLatLike = [28.2335, -29.6232];
export const MAP_PADDING: maplibregl.RequireAtLeastOne<maplibregl.PaddingOptions> = { bottom: 20, top: 100, left: 0, right: 10 };
export const MAP_ATTRIBUTION = 'Acknowledgements: Department of Energy Lesotho (DOE), Lesotho Electricity Company (LEC), Lesotho Renewable Energy and Electricity Access Project (LREEAP), NUL Energy Research Centre (ERC), OnePower Lesotho (1PWR)';

export const BASE_LAYERS = [
    //first position is the activated layer by default
    { text: TEXT_LAYERS.OPEN_STREET_MAP, id: 'open_street_map', paint: {"line_color": "#b9b6c1", "line_width": 1}  },    
    { text: TEXT_LAYERS.TOPOGRAPHY, id: 'topo', paint: {"line_color": "#b9b6c1", "line_width": 1}  },    
    { text: TEXT_LAYERS.BLACK_WHITE, id: 'esri_black_white', paint: {"line_color": "#cacaca", "line_width": 1}  },     
    { text: TEXT_LAYERS.STREET_MAP, id: 'streetmap', paint: {"line_color": "#c9c2a8", "line_width": 3}  },     
    { text: TEXT_LAYERS.SATELLITE, id: 'satellite', paint: {"line_color": "#b9b6c1", "line_width": 1}  },     
];

export const OVERLAY_LAYERS = [
    { text: TEXT_LAYERS.ADMIN, id: LAYER_IDS.GOVS },
    // { text: 'High-voltage grid', id: LAYER_IDS.TRANSMISSION_LINE },
];

export const PAINT_STYLES = {
    SELECTED_GRID_SEGMENT: {
        "line-width": 9,
        "line-color": '#000',
    },
};

export const STYLE: maplibregl.StyleSpecification = {
    version: 8,
    sources: {
        esri_black_white: {
            type: "raster",
            tiles: ["https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"],
            tileSize: 256,
            attribution:
                'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
            maxzoom: 19,
        },
        esri_world: {
            type: "raster",
            tiles: ["https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"],
            tileSize: 256,
            attribution:
                'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
            maxzoom: 19,
        },
        esri_imagery: {
            type: "raster",
            tiles: [
                "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            ],
            tileSize: 256,
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            maxzoom: 19,
        },
        esri_topo: {
            type: "raster",
            tiles: [
                "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
            ],
            tileSize: 256,
            attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
            maxzoom: 19,
        },
        open_street_map: {
            type: "raster",
            tiles: ["https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"],
            tileSize: 256,
            attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            maxzoom: 19,
        },
        custom_raster_wind: {
            type: "raster",
            tiles: ["https://electrifylesotho.gov.ls/tiles/wind/{z}/{x}/{y}.png"],
            tileSize: 256,
            attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            maxzoom: 19,
        },
        custom_raster_pv: {
            type: "raster",
            tiles: ["https://electrifylesotho.gov.ls/tiles/pv/{z}/{x}/{y}.png"],
            tileSize: 256,
            attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            maxzoom: 19,
        },
        custom_raster_nes: {
            type: "raster",
            tiles: ["https://electrifylesotho.gov.ls/tiles/nes/{z}/{x}/{y}.png"],
            tileSize: 256,
            attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            maxzoom: 19,
        },
        terrain: {
            type: 'raster-dem',
            url: `https://api.maptiler.com/tiles/terrain-rgb-v2/tiles.json?key=5RGWbcocxbZyY0nkp8UG`,
            tileSize: 256
        },
    },
    layers: [
        {
            id: "esri_black_white",
            type: "raster",
            source: "esri_black_white",
            layout: { visibility: "none" },
        },
        {
            id: "streetmap",
            type: "raster",
            source: "esri_world",
            layout: { visibility: "none" },
        },
        {
            id: "satellite",
            type: "raster",
            source: "esri_imagery",
            layout: { visibility: "none" },
        },
        {
            id: "topo",
            type: "raster",
            source: "esri_topo",
            layout: { visibility: "none" },
        },
        {
            id: "open_street_map",
            type: "raster",
            source: "open_street_map",
            layout: { visibility: "visible" },
        },
        {
            id: "wind",
            type: "raster",
            source: "custom_raster_wind",
            layout: { visibility: "none" },
        },
        {
            id: "pv",
            type: "raster",
            source: "custom_raster_pv",
            layout: { visibility: "none" },
        },
        {
            id: "nes",
            type: "raster",
            source: "custom_raster_nes",
            layout: { visibility: "none" },
        },
    ],
    terrain: {
        source: 'terrain',
        exaggeration: 1.5
    },
};

export function mapMarker(
    path: any,
    color: string = 'white',
    iconColor: string = 'white',
    width: number = 512,
    height: number = 512,
    size: number = 20,
    scale = 0.5
  ) {
    const icon = typeof path === 'string' ? path : path.icon[4];
    return `
      <svg
          width="${size}"
          height="${size}"
          fill="none" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 560 560"
          style="transform-origin: 0.5em 0.5em;">
          <circle cx="280" cy="280" r="250" fill="none" stroke="black" stroke-width="50"/>
          <circle cx="280" cy="280" r="240" fill="${color}" stroke="${iconColor}" stroke-width="0"/>
          <g transform="translate(280 280)">
          <g transform="translate(0, 0)  scale(${scale}, ${scale})">
              <path
              d="${icon}"
              fill="${iconColor}"
              transform="translate(-${width / 2} -${height / 2})"></path>
          </g>
          </g>
      </svg>`;
  }